export const REG_EXP_CARD_NUMBER = /^([0-9]{4}\s[0-9]{4}\s[0-9]{4}\s[0-9]{4})$/;
export const REG_EXP_MAESTRO_CARD_NUMBER = /^([0-9]{4}\s[0-9]{4}\s[0-9]{4}\s[0-9]{4,6})$/;
export const REG_EXP_CARD_HOLDER = /^[a-zA-Z ]+$/;
export const REG_EXP_CARD_CVV = /^([0-9]{3})$/;
